/**
 * File subscribe-slidein.js.
 *
 * Handles showing the subscibe form slide-in (formerly popup),
 * and opting out users who have submitted the form.
 */

( function() {

  const NEXT_POPUP_KEY = 'cw-next-subscribe-popup'

  /*
    Email subscribe slide-in. This is intentionally not a modal, so the page
    remains scrollable and interactive while the form is visible.
  */
  var subscribe_container = document.getElementById( 'subscribe-popup' );
  if(subscribe_container){
    var subscribe_form = subscribe_container.querySelector( 'form' );
    var subscribe_close = subscribe_container.querySelector( '.close' );
    var subscribe_localStorageKey = subscribe_container.getAttribute('data-ls-key') || NEXT_POPUP_KEY;
    var subscribe_openDelay = subscribe_container.getAttribute('data-open-delay') ? parseInt(subscribe_container.getAttribute('data-open-delay')) : 0;
    var subscribe_scrollDepth = subscribe_container.getAttribute('data-scroll-depth') ? parseInt(subscribe_container.getAttribute('data-scroll-depth')) : 25;
    var subscribe_minScroll = subscribe_container.getAttribute('data-min-scroll') ? parseInt(subscribe_container.getAttribute('data-min-scroll')) : 900;
    var subscribe_isSmallScreen = window.matchMedia('(width < 700px)').matches;
    var subscribe_fallbackTimer;

    // Mobile pages are often much taller; cap both scroll triggers so the prompt
    // appears after real engagement without waiting too far down the page.
    if(subscribe_isSmallScreen){
      subscribe_scrollDepth = Math.min(subscribe_scrollDepth, 15);
      subscribe_minScroll = Math.min(subscribe_minScroll, 600);
    }

    // 7 days for production, 1 hour for other environments.
    var subscribe_reOpenInterval = window.location.host.indexOf('buildcommonwealth') !== -1 ? 1000*60*60*24*7 : 1000*60*60;
    var subscribe_nextPopupTime = localStorage.getItem(subscribe_localStorageKey);

    if(!subscribe_nextPopupTime || (subscribe_nextPopupTime !== 'NEVER' && Date.now() > parseInt(subscribe_nextPopupTime))){
      // Open on engaged scrolling, with a time fallback for visitors who pause above the fold.
      window.addEventListener('scroll', subscribe_openSlideInOnScroll, { passive: true });
      subscribe_fallbackTimer = window.setTimeout(subscribe_openSlideInOnce, subscribe_openDelay);
      subscribe_openSlideInOnScroll();
    }

    if(subscribe_close){
      subscribe_close.addEventListener('click', function(){
        subscribe_closeSlideIn();
        localStorage.setItem(subscribe_localStorageKey, Date.now() + subscribe_reOpenInterval);
      });
    }

    document.addEventListener('keydown', function(event){
      if(event.key === 'Escape' && subscribe_container.classList.contains('is-visible')){
        subscribe_closeSlideIn();
        localStorage.setItem(subscribe_localStorageKey, Date.now() + subscribe_reOpenInterval);
      }
    });

    if(subscribe_form){
      subscribe_form.addEventListener( 'wpcf7submit', function( event ) {
        // if form was submitted successfully, close slide-in and never show popup again
        if(event.detail.status !== 'validation_failed'){
          subscribe_closeSlideIn();
          subscribe_optOutForever()
        }
      }, false );
    }
  }

  /* 
    Opt user out of email popup
    Called when popup form OR content gate form is submitted  
  */
  function subscribe_optOutForever(){
    localStorage.setItem(NEXT_POPUP_KEY, 'NEVER');
  } 

  function subscribe_openSlideIn(){
    if(!subscribe_container){
      return;
    }
    // load the Hubspot forms script
    if(typeof window.cwLoadHubSpotForms === 'function'){
      window.cwLoadHubSpotForms();
    }
    subscribe_container.hidden = false;
    subscribe_container.setAttribute('aria-hidden', 'false');
    // Force layout so the browser paints the off-canvas state first.
    subscribe_container.offsetHeight;
    window.requestAnimationFrame(function(){
      subscribe_container.classList.add('is-visible');
    });
  }

  function subscribe_openSlideInOnce(){
    if(!subscribe_container || subscribe_container.classList.contains('is-visible')){
      return;
    }
    // Whichever trigger wins should clean up the other one.
    window.removeEventListener('scroll', subscribe_openSlideInOnScroll);
    window.clearTimeout(subscribe_fallbackTimer);
    subscribe_openSlideIn();
  }

  function subscribe_openSlideInOnScroll(){
    var scrollY = window.scrollY;
    var scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
    var scrollPercent = scrollableHeight > 0 ? (scrollY / scrollableHeight) * 100 : 0;

    // Use either a fixed distance or percentage so long and short pages both behave well.
    if(scrollY >= subscribe_minScroll || scrollPercent >= subscribe_scrollDepth){
      subscribe_openSlideInOnce();
    }
  }

  function subscribe_closeSlideIn(){
    if(!subscribe_container){
      return;
    }
    subscribe_container.classList.remove('is-visible');
    subscribe_container.setAttribute('aria-hidden', 'true');
    window.setTimeout(function(){
      if(!subscribe_container.classList.contains('is-visible')){
        subscribe_container.hidden = true;
      }
    }, 250);
  }

}() );
